export function readUserDisplayName(metadata: unknown): string {
  if (!metadata || typeof metadata !== "object") return "";
  const record = metadata as Record<string, unknown>;
  const value =
    record.full_name ?? record.name ?? record.display_name ?? record.user_name;
  return typeof value === "string" ? value.trim() : "";
}

export function readUserAvatarUrl(metadata: unknown): string {
  if (!metadata || typeof metadata !== "object") return "";
  const record = metadata as Record<string, unknown>;
  const value = record.avatar_url ?? record.picture ?? record.avatarUrl;
  return typeof value === "string" ? value.trim() : "";
}

export function readUserInitials(name: string): string {
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("");
  return initials || "TP";
}
